import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Compact chip label: "Multi-disciplinary (Engineering, Law, Mgmt)" -> "Engineering +2"
export function summarizeList(value, keep = 1) {
  let v = String(value || "");
  const inside = v.match(/\(([^)]+)\)/);
  if (inside) v = inside[1]; // prefer the programme list inside parentheses
  const parts = v.replace(/[()]/g, " ").split(/[,/•]/).map((s) => s.trim()).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length <= keep) return parts.join(" • ");
  return `${parts.slice(0, keep).join(" • ")} +${parts.length - keep}`;
}
